/**
 * @generated SignedSource<<b30e0a22273f4a358ec73a88f0a6cb43>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useRecentItems$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useRecentItemsPaged">;
  readonly " $fragmentType": "useRecentItems";
};
export type useRecentItems$key = {
  readonly " $data"?: useRecentItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRecentItems">;
};

import useRecentItemsRefetchableQuery_graphql from './useRecentItemsRefetchableQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "kind": "RootArgument",
      "name": "keyword"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": useRecentItemsRefetchableQuery_graphql
    }
  },
  "name": "useRecentItems",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "count",
          "variableName": "count"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useRecentItemsPaged"
    }
  ],
  "type": "Query"
};

(node as any).hash = "c7427eba8c734344b51198ca307b6328";

export default node;
